import React, { useEffect } from 'react';
import { useSystemSettings } from '@/contexts/SystemSettingsContext';
import { useKYCCheck } from '@/hooks/useKYCCheck';

interface GlobalSettingsListenerProps {
  children: React.ReactNode;
}

export const GlobalSettingsListener: React.FC<GlobalSettingsListenerProps> = ({ children }) => {
  const { settings } = useSystemSettings();
  const { refreshSettings: refreshKYCSettings } = useKYCCheck();

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    
    // เมื่อการตั้งค่าระบบเปลี่ยนแปลง ให้รีเฟรช KYC settings (debounced)
    if (
      settings.kyc_warning_enabled ||
      settings.require_kyc_for_deposit ||
      settings.require_kyc_for_withdraw ||
      settings.require_kyc_for_transfer
    ) {
      // Clear previous timeout to prevent multiple calls
      clearTimeout(timeoutId);
      
      // Debounce the refresh call
      timeoutId = setTimeout(() => {
        console.log('🔄 KYC settings changed via real-time, refreshing...');
        refreshKYCSettings();
      }, 1000);
    }

    return () => clearTimeout(timeoutId);
  }, [
    settings.kyc_warning_enabled,
    settings.require_kyc_for_deposit,
    settings.require_kyc_for_withdraw,
    settings.require_kyc_for_transfer
  ]);

  useEffect(() => {
    // เมื่อการตั้งค่าระบบเปลี่ยนแปลง ให้อัพเดท document title หรือ global configurations
    if (settings.signup_enabled) {
      console.log('🔄 Signup settings updated:', settings.signup_enabled);
    }

    if (settings.exchange_rate) {
      console.log('🔄 Exchange rate updated:', settings.exchange_rate);
    }
  }, [settings]);

  return <>{children}</>;
};